/**
 * Jest configuration helpers for consuming apps.
 *
 * Usage in jest.config.js:
 *
 *   const { jestTransformPackages } = require('@planningcenter/chat-react-native/jest')
 *
 *   const ignorePatterns = [
 *     ...yourPatterns,
 *     ...jestTransformPackages,
 *   ].join('|')
 *
 *   module.exports = {
 *     transformIgnorePatterns: [`node_modules/(?!${ignorePatterns})`],
 *   }
 */
export const jestTransformPackages = [
  '@planningcenter/chat-react-native',
  '@planningcenter/emoji-keyboard',
  '@fortawesome',
]
